import { isDocsDocumentationPath } from '@common/utils/isDocsDocumentationPath'

const DOCS_TITLE_SUFFIX = 'Docs'

/** Academy app URL for links from docs (see NEXT_PUBLIC_WEB_ACADEMY_URL). */
export function getAcademyExternalUrl(): string {
  const raw = process.env.NEXT_PUBLIC_WEB_ACADEMY_URL?.trim()

  if (!raw || raw.startsWith('BAKED_')) {
    return ''
  }

  return raw.replace(/\/$/, '')
}

export function buildDocumentationHref(slug: string): string {
  return slug ? `/${slug}` : '/'
}

export function isDocumentationPath(pathname: string): boolean {
  return isDocsDocumentationPath(pathname)
}

export function formatDocsPageTitle(pageTitle: string): string {
  return `${pageTitle} | ${DOCS_TITLE_SUFFIX}`
}

export function formatQuickStartPageTitle(pageTitle: string): string {
  return `${pageTitle} | Quick Start | ${DOCS_TITLE_SUFFIX}`
}
